










 

 























const node = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "spotlightSearchQuery",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ReflectionGroup_meeting",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DraggableReflectionCard_meeting"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ReflectionGroupHeader_meeting"
    },
    {
      "kind": "InlineDataFragmentSpread",
      "name": "useSpotlightResults_meeting",
      "selections": [
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "RetroReflectionGroup",
              "kind": "LinkedField",
              "name": "spotlightGroup",
              "plural": false,
              "selections": [
                (v0/*: any*/)
              ],
              "storageKey": null
            },
            (v1/*: any*/)
          ]
        }
      ],
      "args": null,
      "argumentDefinitions": []
    },
    (v0/*: any*/),
    {
      "kind": "ClientExtension",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "localPhase",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "phaseType",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "localStage",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isComplete",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isViewerDragInProgress",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "RetroReflectionGroup",
          "kind": "LinkedField",
          "name": "spotlightGroup",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "RetroReflection",
              "kind": "LinkedField",
              "name": "reflections",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "isViewerDragging",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        (v1/*: any*/)
      ]
    }
  ],
  "type": "RetrospectiveMeeting",
  "abstractKey": null
};
})();

(node ).hash = "3d33087225a5e716593423185d467a49";

export default node;
